import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import { Response, Headers, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { Auth } from '../class/Auth';
import { Broadcaster } from './Broadcaster';
import { RequestOptions, ResponseContentType } from '@angular/http';
import { Expense } from '../class/expense/expense';
import { Category } from '../class/category/category';
import { Rooftop } from '../class/rooftop';
import {  responseRtbData } from '../class/http/res/response-rtb-data';
import { ListMediaCategory } from '../class/media-category/list-media-category';
import { responseListProduct } from '../class/http/res/response-list-product';
import {  responseUpdateExpensesProduct } from '../class/http/res/response-update-expenses-product';
import { responseRemoveExpense } from '../class/http/res/response-remove-expense';
import { responseSaveExpense } from '../class/http/res/response-save-expense';
import { responseClientList } from '../class/http/res/response-client-list';
import { responseGetUser } from '../class/http/res/response-get-user';
import { Error } from '../class/broadcaster/app/error';
import { responseGetDashboard } from '../class/http/res/response-get-dashboard';
import { responseUpdateCategory } from '../class/http/res/response-update-category';
import { Rename } from '../class/rename/rename';
import { GoogleConfig } from '../class/info-expense/google-config';
import {  responseGetExpensePeriod } from '../class/http/res/response-get-expense-reriod';
import { responseGetExpense } from '../class/http/res/response-get-expense';
import { responsecreateProduct } from '../class/http/res/response-create-product';
import { CreateProduct } from '../rtb/info/class/create-product';
import { DeleteFileExpense } from '../rtb/info/class/delete-file-expense';
import { responseRemoveFileExpense } from '../class/http/res/response-remove-file-expense';
import { responseGetExpenseFiles } from '../class/http/res/response-get-expense-files';
import { responseGetСategory } from '../class/http/res/response-get-category';
import { requestGetCategory } from '../class/http/req/request-get-category';
import { requestXLSBudget } from '../class/http/req/request-xls-budget';
import { requestRtbData } from '../class/http/req/request-get-rtb-data';
import { requestGetStats } from '../class/http/req/request-get-stats';
import { responseGetStats } from '../class/http/res/response-get-stats';
import { responseAddExpense } from '../class/http/res/response-add-expense';
import {  responseUpdateTargetBudget } from '../class/http/res/response-update-target-budget';
import { responseActualBudget } from '../class/http/res/response-update-actual-budget';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { ColorCategory } from '../interfaces/category/color-category';
import { HttpError } from '../interfaces/http-error';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class SingService {
    public identity: {
        username: string;
        email: string;
        name: any;
        group: number;
    };
    settings: any = { api: { url: '/api' } };
    private Auth: Auth = { access_token: "", identity: null, loggedIn: "" };
   // private headers = new Headers({ 'Content-Type': 'application/json' });
    private headers = {
        headers: new HttpHeaders({
          'Content-Type':  'application/json'
        })
      };
    constructor(private http: HttpClient, private broadcaster: Broadcaster) {
        if (this.getAuthCookie() !== "") {

            /* this.headers.append(
                 'Authorization',
                 'Bearer ' + this.getAuthCookie()
             );*/
            this.Auth = {
                access_token: /*this.getAuthCookie()*/ "",
                loggedIn: this.getAuthCookie(),
                identity: JSON.parse(window.localStorage.getItem('identity')),
            };
           
        }
    }
    getAuthCookie(): string {
        // return document.cookie.replace(/(?:(?:^|.*;\s*)access_token\s*\=\s*([^;]*).*$)|^.*$/, "$1");
        let cookie = document.cookie.replace(/(?:(?:^|.*;\s*)loggedIn\s*\=\s*([^;]*).*$)|^.*$/, "$1");
        return (cookie.length === 1) ? "" : cookie;
    }
    getAuthData(): Auth {
        return this.Auth;
    }
    /*testpostData(user: User): Auth {
        window.sessionStorage.setItem(
            'access_token',
            'FD1VyxqKw0YA96PjT2TzF9EzId32ULN9'
        );
        window.localStorage.setItem(
            'identity',
            JSON.stringify({
                username: 'demetrio77@gmail.com',
                email: '',
                name: 'ivan',
                group: 10,
            })
        );
        this.Auth = {
            access_token: 'FD1VyxqKw0YA96PjT2TzF9EzId32ULN9',
            identity: {
                username: 'demetrio77@gmail.com',
                email: '',
                name: 'ivan',
                group: 10,

            },
        };
        return this.Auth;
    }*/
    removeMediaCategory(data: any) {

        return this.http
            .post(`${this.settings.api.url}/media/remove?dealerGroupId=${data.dealerGroupId}&year=${data.year}&month=${data.month}&productCategoryId=${data.productCategoryId}`, data, this.headers)
            .map(res => res)
            .catch((error: any) => {
                if (data.blockError === undefined) {
                    return this.catchErrorResponse(error);
                } else {
                    return Observable.throw(error);
                }
            });
    }

    removeCategory(data: any) {

        return this.http
            .post(`${this.settings.api.url}/expense/delete-category`, data, this.headers)
            .map(res => res)
            .catch((error: any) => {
                if (data.blockError === undefined) {
                   return this.catchErrorResponse(error);
                } else {
                    return Observable.throw(error);
                }
                
            });
    }

    removeProduct(data: any) {

        return this.http
            .post(`${this.settings.api.url}/expense/delete-product`, data, this.headers)
            .map(res => res)
            .catch((error: any) => {
                if (data.blockError === undefined) {
                    return this.catchErrorResponse(error);
                } else {
                    return Observable.throw(error);
                }
            });
    }

    removeExpense(id: number, blockError: boolean) {
        var params = { id: id };
        return this.http
            .post(`${this.settings.api.url}/expense/delete`, params, this.headers)
            .map((res:any) => new responseRemoveExpense(res.data))
            .catch((error: any) => {
                if (!blockError) {
                    return this.catchErrorResponse(error);
                } else {
                    return Observable.throw(error);
                }
            });
    }
    LogOut() {
        var params = { /*access_token: this.Auth.access_token*/ };
        return this.http
            .post(`${this.settings.api.url}/users/logout`, params, this.headers)
            .map(res => res)
            .catch( error => this.catchErrorResponse(error));
    }
    getConfGoogle() {
        return this.http
            .get(`${this.settings.api.url}/third-party/gd/account`, this.headers)
            .map((res:any) => new GoogleConfig(res.data))
            .catch( error => this.catchErrorResponse(error));
    }

    getSalesObjectives(data: any) {
        return this.http
            .get(`${this.settings.api.url}/sales-objectives/get?dealerShipId=${data.dealerShipId}&year=${data.year}`, this.headers)
            .map(res => res)
            .catch( error => this.catchErrorResponse(error));
    }
    getMediaCalendar(data: any) {
        return this.http
            .get(`${this.settings.api.url}/media/get?dealerGroupId=${data.dealerGroupId}&year=${data.year}&month=${data.month}&productCategoryId=${data.productCategoryId}`, this.headers)
            .map(res => res)
            .catch( error => this.catchErrorResponse(error));
    }
    getListProducts(dealerGroupId: Number) {
        return this.http
            .get(`${this.settings.api.url}/category/list?dealerGroupId=${dealerGroupId}&withProducts=true`, this.headers)
            .map((res:any) => new responseListProduct(res.data))
            .catch( error => this.catchErrorResponse(error));
    }
    getCategori(productCategoryId: number, withProducts: boolean) {
        return this.http
            .get(`${this.settings.api.url}/category/get?productCategoryId=${productCategoryId}&withProducts=${withProducts}`, this.headers)
            .map(res => res)
            .catch( error => this.catchErrorResponse(error));
    }
    getExpense(id: number) {
        return this.http
            .get(`${this.settings.api.url}/expense/get?id=${id}`, this.headers)
            .map((res:any) =>  new responseGetExpense ( res.data ))
            .catch( error => this.catchErrorResponse(error));
    }
    sortProduct(lastId: any, nowId: number, productCategoryId: number) {
        let params = { ordinal: nowId, productCategoryId: productCategoryId };
        // console.log("params", params);
        //.post(`${this.settings.api.url}/product/move?productId=${lastId}&dealerGroupId=${dealerGroupId}&productCategoryId=${productCategoryId}`, params, {

        return this.http
            .post(`${this.settings.api.url}/product/move?productId=${lastId}`, params, this.headers)
            .map(res => res)
            .catch( error => this.catchErrorResponse(error));
    }
    sortExpense(lastId: any, nowId: number) {
        let params = { ordinal: nowId };
        // console.log("params", params);
        //.post(`${this.settings.api.url}/product/move?productId=${lastId}&dealerGroupId=${dealerGroupId}&productCategoryId=${productCategoryId}`, params, {

        return this.http
            .post(`${this.settings.api.url}/expense/move?id=${lastId}`, params, this.headers)
            .map(res => res)
            .catch( error => this.catchErrorResponse(error));
    }
    CreateCategory(dealerGroupId: number, name: string, color: string) {
        let params = {
            name: name,
            considerInTotal: 1,
            color: color
        };
        //  console.log("params", params);
        return this.http
            .post(`${this.settings.api.url}/category/create?dealerGroupId=${dealerGroupId}`, params, this.headers)
            .map(res => res)
            .catch( error => this.catchErrorResponse(error));
    }
    addDashboard(dealerGroupId: number, name: string, link: string) {
        let params = {
            name: name,
            url: link
        };
        //  console.log("params", params);
        return this.http
            .post(`${this.settings.api.url}/dashboard/create?dealerGroupId=${dealerGroupId}`, params, this.headers)
            .map(res => res)
            .catch( error => this.catchErrorResponse(error));
    }
    saveSalesObjectives(data: any) {

        return this.http
            .post(`${this.settings.api.url}/sales-objectives/save?dealerShipId=${data.dealerShipId}&year=${data.year}`, data.data,this.headers)
            .map(res => res)
            .catch( error => this.catchErrorResponse(error));
    }
    sortCategory(lastId: any, nowId: number) {
        let params = { ordinal: nowId };
        //  console.log("params", params);
        return this.http
            .post(`${this.settings.api.url}/category/move?productCategoryId=${lastId}`, params, this.headers)
            .map(res => res)
            .catch( error => this.catchErrorResponse(error));
    }
    uploadBudget(data: any, dealerShipId: number, id: number, year: number, month: number) {
        let params = { uploadFile: data, dealerShipId: dealerShipId, year: year, month: month };
        //  console.log("params", params);
        return this.http
            .post(`${this.settings.api.url}/budget/upload?id=${id}`, params, this.headers)
            .map(res => res)
            .catch( error => this.catchErrorResponse(error));
    }
    setMediaCategory(id: Number, isMedia: number) {
        return this.http
            .post(`${this.settings.api.url}/category/as-media?productCategoryId=${id}`, { isMedia: isMedia }, this.headers)
            .map(res => res)
            .catch( error => this.catchErrorResponse(error));
    }
    removeDashboard(id: Number) {
        return this.http
            .post(`${this.settings.api.url}/dashboard/delete?dashboardId=${id}`, {}, this.headers)
            .map(res => res)
            .catch( error => this.catchErrorResponse(error));
    }
    saveDashboard(data: any) {
        return this.http
            .post(`${this.settings.api.url}/dashboard/update?dashboardId=${data.id}`, data,this.headers)
            .map(res => res)
            .catch( error => this.catchErrorResponse(error));
    }
    createProduct(data: CreateProduct) {
        return this.http
            .post(`${this.settings.api.url}/product/create?productCategoryId=${data.productCategoryId}`, data, this.headers)
            .map((res:any) => new responsecreateProduct (res.data))
            .catch( error => this.catchErrorResponse(error));
    }
    updateProduct(data: Rename) {

        return this.http
            .post(`${this.settings.api.url}/product/update?productId=${data.id}`, data, this.headers)
            .map((res:any) => new responseUpdateCategory (res.data))
            .catch( error => this.catchErrorResponse(error));
    }
    setColorCategory(data: ColorCategory) {

        return this.http
            .post(`${this.settings.api.url}/category/update?productCategoryId=${data.id}`, data,this.headers)
            .map((res:any) => new responseUpdateCategory(res.data))
            .catch( error => this.catchErrorResponse(error));
    }
    updateCategory(data: Rename) {

        return this.http
            .post(`${this.settings.api.url}/category/update?productCategoryId=${data.id}`, data,this.headers)
            .map((res:any) => new responseUpdateCategory(res.data))
            .catch( error => this.catchErrorResponse(error));
    }
    addExpense(data: any) {
        return this.http
            .post(`${this.settings.api.url}/expense/create?dealerShipId=${data.dealerShipId}&month=${data.month}&year=${data.year}`, data, this.headers)
            .map((res:any) => new responseAddExpense(res.data))
            .catch( error => this.catchErrorResponse(error));
    }
    saveMediaCalendar(data: any): Observable<any> {
        return this.http.post(`${this.settings.api.url}/media/save`, data,this.headers).map(res => res)
        .catch( error => this.catchErrorResponse(error));
    }
    updateBudget(data: any) {
      
        return this.http
            .post(`${this.settings.api.url}/budget/update?dealerShipId=${data.dealerShipId}&year=${data.year}&month=${data.month}`, data, this.headers)
            .map(res => res)
            .catch( error => this.catchErrorResponse(error));
    }
    removeFileExpense(fileid: number) {
        return this.http
            .post(`${this.settings.api.url}/files/delete?fileId=${fileid}`, {}, this.headers)
            .map((res:any) => new responseRemoveFileExpense(res.data))
            .catch( error => this.catchErrorResponse(error));
    }
    updateTargetBudgetExpense(data: any) {
        return this.http
            .post(`${this.settings.api.url}/expense/update?id=${data.id}`, data, this.headers)
            .map(res => res)
            .catch( error => this.catchErrorResponse(error));
    }
    setSummExpense(data: any) {
        return this.http
            .post(`${this.settings.api.url}/expense/update-product?year=${data.year}&month=${data.month}&dealerShipId=${data.dealerShipId}&productId=${data.productId}`, data, this.headers)
            .map((res:any) => new responseUpdateExpensesProduct(res.data))
            .catch( error => this.catchErrorResponse(error));
    }
    saveExpense(data: any) {
        return this.http
            .post(`${this.settings.api.url}/expense/update?id=${data.id}`, data, this.headers)
            .map((res:any) => new responseSaveExpense(res.data))
            .catch( error => this.catchErrorResponse(error));
    }
    singIn(data: any) {

        return this.http
            .post(`${this.settings.api.url}/users/login`, data,this.headers)
            .map((res:any) => new responseGetUser(res.data.identity))
            .catch( error => this.catchErrorResponse(error));
    }
    getXLSBudget(data: requestXLSBudget) {
        const options = new RequestOptions({ responseType: ResponseContentType.Blob });
      
        return this.http
            .get(`${this.settings.api.url}/budget/csv?dealerGroupId=${data.dealerGroupId}&year=${data.year}&month=${data.month}&budget=${data.budget}${data.dealerships}`,{responseType: 'blob'})
            .map(res => res)
            .catch((error: any) => {
            
                this.showErrorMessage('Validation Error', { "dealerShipId": ["Budget not found"] }, 422);

                return Observable.throw(error);
            });
    }
    getPDFCalendar(data: any) {
        const options = new RequestOptions({ responseType: ResponseContentType.Blob });

        return this.http
            .get(`${this.settings.api.url}/budget/calendar?dealerGroupId=${data.dealerGroupId}&year=${data.year}&month=${data.month}&budget=${data.budget}${data.productCategoryId}${data.dealerships}`,{responseType: 'blob'})
            .map(res => res)
            .catch((error: any) => {
                this.showErrorMessage('Validation Error', { "dealerShipId": ["Budget not found"] }, 422);

                return Observable.throw(error);
            });
    }
    getProduct(id: String) {
        return this.http
            .get(`${this.settings.api.url}/product/get?productId=${id}`, this.headers)
            .map(res => res)
            .catch( error => this.catchErrorResponse(error));
    }
    getClients() {
        return this.http
            .get(`${this.settings.api.url}/clients/list`, this.headers)
            .map((res:any) => new responseClientList(res.data))
            .catch( error => this.catchErrorResponse(error));
    }
    getDealerRooftops(data: any) {
        var params = new URLSearchParams();
        params.set('dealerGroupId', String(data.dealerGroupId));

        return this.http
            .get(`${this.settings.api.url}/rooftops/list?${params.toString()}`, this.headers)
            .map(res => res)
            .catch( error => this.catchErrorResponse(error));
    }
    getDashboard(dealerGroupId: number) {


        return this.http
            .get(`${this.settings.api.url}/dashboard/list?dealerGroupId=${dealerGroupId}`, this.headers)
            .map((res:any) => new responseGetDashboard(res.data))
            .catch( error => this.catchErrorResponse(error));
    }
    getFilePermission(id: string, token: String, serviceAccount: String) {
        let headers = {
            headers: new HttpHeaders({
                'Content-Type':  'application/json',
                'Authorization':
                    'Bearer ' + token
              })
        };
        let params = {
            'value': serviceAccount,
            'type': 'anyone',
            'role': 'reader',
            'sendNotificationEmails': false
        }

        return this.http
            .post(`https://www.googleapis.com/drive/v2/files/${id}/permissions`, params, headers)
            .map(res => res)
            .catch( error => this.catchErrorResponse(error));
    }
    getFileDataGoogleDrive(id: string, token: string) {
        let headers = {
            headers: new HttpHeaders({
                'Content-Type':  'application/json',
                'Authorization':
                    'Bearer ' + token
              })
        };

        return this.http
            .get(`https://www.googleapis.com/drive/v2/files/${id}`,headers)
            .map(res => res)
            .catch( error => this.catchErrorResponse(error));
    }

    getFilesFolderGoogleDrive(id: string) {
        return this.http
            .get(`${this.settings.api.url}/third-party/gd/list?fileId=${id}`, this.headers)
            .map(res => res)
            .catch( error => this.catchErrorResponse(error));
    }
    getExpenseFiles(id: number,folderId:number) {
        return this.http
            .get(`${this.settings.api.url}/files/folder?expenseId=${id}&folderId=${folderId}`, this.headers)
            .map((res:any) => new responseGetExpenseFiles (res.data))
            .catch( error => this.catchErrorResponse(error));
    }
    getExpensePeriod(data: any) {
        return this.http
            .get(`${this.settings.api.url}/expense/find?dealerShipId=${data.dealerShipId}&productCategoryId=${data.productCategoryId}&productId=${data.productId}&startDate=${data.startDate}&endDate=${data.endDate}`, this.headers)
            .map((res:any) => new responseGetExpensePeriod(res.data))
            .catch( error => this.catchErrorResponse(error));
    }
   
    getСategory(data: requestGetCategory, viewType: String) {
        let url: string = '';
        if (viewType === 'daysOfMonth') {
            url = `${this.settings.api.url}/expense/category?productCategoryId=${data.id}&dealerShipId=${data.dealerShipId}&year=${data.year}&month=${data.month}`;
        }
        if (viewType === 'monthsOfQuarter') {
            url = `${this.settings.api.url}/expense/category?productCategoryId=${data.id}&dealerShipId=${data.dealerShipId}&year=${data.year}&quarter=${data.quarter}`;
        }
        if (viewType === 'monthsOfYear') {
            url = `${this.settings.api.url}/expense/category?productCategoryId=${data.id}&dealerShipId=${data.dealerShipId}&year=${data.year}`;
        }
        return this.http
            .get(url, this.headers)
            .map((res:any) => new responseGetСategory(res.data))
            .catch( error => this.catchErrorResponse(error));
    }
    getStats(data: requestGetStats, viewType: String) {
        let url: string = '';
        if (viewType === 'daysOfMonth') {
            url = `${this.settings.api.url}/budget/stats?dealerGroupId=${data.dealerGroupId}&dealerShipId=${data.dealerShipId}&year=${data.year}&month=${data.month}`;
        }
        if (viewType === 'monthsOfQuarter') {
            url = `${this.settings.api.url}/budget/stats?dealerGroupId=${data.dealerGroupId}&dealerShipId=${data.dealerShipId}&year=${data.year}&quarter=${data.quarter}`;
        }
        if (viewType === 'monthsOfYear') {
            url = `${this.settings.api.url}/budget/stats?dealerGroupId=${data.dealerGroupId}&dealerShipId=${data.dealerShipId}&year=${data.year}`;
        }

        return this.http
            .get(url, this.headers)
            .map((res:any) => new responseGetStats(res.data.stats))
            .catch( error => this.catchErrorResponse(error));
    }
    /*getStatsYear(data: any) {
        return this.http
            .get(`${this.settings.api.url}/budget/stats?dealerGroupId=${data.dealerGroupId}&dealerShipId=${data.dealerShipId}&year=${data.year}`, {
                headers: this.headers,
            })
            .map(res => res)
            .catch((error: any) => {
                if (error.status === 401 || error.status === 403) {
                    this.broadcaster.broadcast(
                        'AuthError',
                        String(error.status)
                    );
                }
                return Observable.throw(error);
            });
    }*/
  
    getRtbData(data: requestRtbData) {
        /*
     dealerGroupId - это номер нашего клиента, он в урле страницы
     dealerShipId - номер руфтопа (салон нашего клиента), если 0, то обсчитываются все салоны
     year, month - понятно
     quarter - квартал (1 - январь-март, 2 - апрель-июнь, 3 - июль-сентябрь, 4 - октябрь - декабрь)
     viewType - вид отображения основной сетки страницы
     daysOfMonth - дни месяца ,
     weeksOfMonth - недели месяца,
     monthsOfQuarter - месяцы квартала,
     monthsOfYear - месяцы года*/
        var params = new URLSearchParams();
        params.set('dealerGroupId', String(data.dealerGroupId));
        params.set('dealerShipId', String(data.dealerShipId));
        params.set('year', String(data.year));
        if (data.viewType === 'daysOfMonth') {
            params.set('month', String(data.month));
        }
        if (data.viewType === 'monthsOfQuarter') {
            params.set('quarter', String(data.quarter));
        }




        return this.http
            .get(`${this.settings.api.url}/budget/rtb?${params.toString()}`,this.headers)
            .map((res:any) => new responseRtbData(res.data.categories,res.data.mediaCategories,res.data.rooftops,res.data.stats,res.data.weeks))
            .catch( error => this.catchErrorResponse(error));
    }
    getBudgetData(data: any) {
        let params = new URLSearchParams();
        params.set('dealerGroupId', String(data.dealerGroupId));
        if (data.dealerShipId) {
            params.set('dealerShipId', String(data.dealerShipId));
        }
        if (data.month) {
            params.set('month', String(data.month));
        }
        if (data.year) {
            params.set('year', String(data.year));
        } if (data.quarter) {
            params.set('quarter', String(data.quarter));
        }
        return this.http.post(`${this.settings.api.url}/budget/total?${params.toString()}`, {
            headers: this.headers
        })
        .map(res => res)
        .catch( error => this.catchErrorResponse(error));
    }
    updateTargetBudget(data: any) {
        return this.http
            .post(`${this.settings.api.url}/expense/update-target-budget?id=${data.id}`, data, this.headers)
            .map((res:any) => new responseUpdateTargetBudget(res.data))
            .catch( error => this.catchErrorResponse(error));
    }
    updateActualBudget(data: any) {
        return this.http
            .post(`${this.settings.api.url}/expense/update-actual-budget?id=${data.id}`, data, this.headers)
            .map((res:any) => new responseActualBudget(res.data))
            .catch( error => this.catchErrorResponse(error));
    }
    catchErrorResponse (error: HttpErrorResponse) {
       this.showErrorMessage(error.error.errorName, error.error.errors, error.error.status);
        return Observable.throw(error.error);
    }
    showErrorMessage(name: string, error: any, status: number) {
        let erros = [];
        for (let i = 0; i < Object.keys(error).length; i++) {
            erros.push(error[Object.keys(error)[i]]);
        }
        if (status !== 403) {
            this.broadcaster.broadcast(
                'InfoError',
                new Error (name, erros )
            );
        }
        if (status === 403) {
            this.broadcaster.broadcast(
                'AuthError',
                String(status)
            );
        }

    }

}



// WEBPACK FOOTER //
// ./src/app/components/service/sing.service.ts